import styled from "styled-components";
import { colorsPalettes, mixins, fonts } from "@similarweb/styles";

export const StyledTooltipHeader = styled.div`
    line-height: 20px;
    ${mixins.setFont({
        $size: 13,
        $weight: 700,
        $color: colorsPalettes.bluegrey[100],
        $family: fonts.$robotoFontFamily,
    })}
`;
export const StyledTooltipBody = styled.div`
    line-height: 20px;
    font-weight: normal;
    ${mixins.setFont({
        $size: 13,
        $weight: 400,
        $color: colorsPalettes.bluegrey[100],
        $family: fonts.$robotoFontFamily,
    })}
`;
export const StyledTooltipLinkWrapper = styled.div`
    a {
        line-height: 20px;
    }
`;
